export function getDefaultColors() {
  return [
    '#0821a9', '#0a1c4b', '#197f9b', '#29068d',
    '#4001b4', '#443803', '#4c4c4c', '#8a2216',
    '#a70655', '#7c5201', '#9f3c3a', '#367c2c',
    '#1e967c', '#53ac61', '#5d6e9f'
  ];

}
